/// <amd-module name="Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataSelectors" />
import { IProjectData, ITfsPageData } from "Tfs/Platform/Page";
import { ITfsPageDataAwareState } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataContracts";

export function getTfsPageDataState(state: ITfsPageDataAwareState): ITfsPageData | null {
    return state.tfsPageData;
}

export function currentProject(state: ITfsPageDataAwareState): IProjectData | undefined {
    return state.tfsPageData ? state.tfsPageData.project : undefined;
}
